module.exports = __webpack_public_path__ + "static/media/13-ball.9a39ff3e.png";